import { useSearchParams } from "react-router"
import { z } from "zod"

import { updateSearchParams } from "@/helpers/url"

const searchOptionsSchema = z.object({
  campaignIds: z.array(z.string()).default([]),
})

type MissedCallsSearchOptions = z.infer<typeof searchOptionsSchema>

const useMissedCallsSearch = () => {
  const [params, setParams] = useSearchParams()

  const searchOptions = searchOptionsSchema.parse({
    campaignIds: params.getAll("campaignIds") || [],
  })

  const onChange =
    <K extends keyof MissedCallsSearchOptions>(key: K) =>
    (value?: MissedCallsSearchOptions[K]) => {
      setParams((current) => {
        updateSearchParams(current, key.toString(), value as string[])

        return current
      })
    }

  return { onChange, searchOptions }
}

export { useMissedCallsSearch }
